import type {
  ICellRendererComp,
  ICellRendererParams,
} from "ag-grid-enterprise";

export class DetailCellRenderer implements ICellRendererComp {
  private eGui!: HTMLElement;

  init(params: ICellRendererParams) {
    this.eGui = document.createElement("div");
    this.eGui.setAttribute("role", "gridcell");
    this.eGui.innerHTML = params.data.customDetailContent || "";
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }
}
